// extracted by mini-css-extract-plugin
export default {"title":"styles_title__27H-s","p":"styles_p__LphxP"};